import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'app/components/toasts/toasts.service';
import { CoreConfigService } from '@core/services/config.service';
import { AuthenticationService } from 'app/auth/service';
import { DataService } from 'app/services/data.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent implements OnInit, OnDestroy, AfterViewInit {

  public servicesPrice = {
    SIX_MONTH_PACK: 299.94,
    YEARLY_PACK: 479.95,
    ENTERPRISE_PACK: 1800
  }
  public promoid: string = '';
  public codeError: boolean = false;
  public userStatus: string = '';
  public isLoading: boolean = false;
  public errorMessage = null;
  private _unsubscribeAll: Subject<any>;

  public cardForm: FormGroup = new FormGroup({
    number: new FormControl(null),
    expMonth: new FormControl(null),
    expYear: new FormControl(null, [Validators.minLength(2)]),
    cvc: new FormControl(null),
    product: new FormControl(null),
  });

  public referalCode: FormControl = new FormControl(null);

  constructor(
    private _coreConfigService: CoreConfigService,
    private _authenticationService: AuthenticationService,
    private _dataService: DataService,
    private _toastrService: ToastService,
    private _router: Router
    ) {
      this._unsubscribeAll = new Subject();
      // Configure the layout
      this._coreConfigService.config = {
        layout: {
          menu: {
            hidden: true,
            collapsed: false
          },
          customizer: false,
          enableLocalStorage: false
        }
      };
    }

  ngOnInit(): void {
    let user = this._authenticationService.currentUserValue;
    this.userStatus = user.user.subscriptionStatus;
    if(user.user.stripeData.subsciption){
      this.cardForm.get('product').setValue(user.user.stripeData.subsciption.product);
    }

    if(this.userStatus == 'free'){
      let controls = this.cardForm.controls;
      for (const key in controls) {
        this.cardForm.get(key).setValidators(Validators.required);
        this.cardForm.get(key).updateValueAndValidity();
      }
    }
  }

  ngAfterViewInit(): void {
    this.referalCode.valueChanges.pipe(debounceTime(350), takeUntil(this._unsubscribeAll)).subscribe((code) => {
      this.codeError = false;
      if(code){
        this._dataService.checkPaymentDiscount(code).toPromise().then((res) => {
          if(res.success){
            this.promoid = res.data.id;
            let discount = res.data.coupon.percent_off;
            this.servicesPrice.SIX_MONTH_PACK = parseFloat((this.servicesPrice.SIX_MONTH_PACK - ((this.servicesPrice.SIX_MONTH_PACK / 100) * discount)).toFixed(2));
            this.servicesPrice.YEARLY_PACK = parseFloat((this.servicesPrice.YEARLY_PACK - ((this.servicesPrice.YEARLY_PACK / 100) * discount)).toFixed(2));
            this.servicesPrice.ENTERPRISE_PACK = parseFloat((this.servicesPrice.ENTERPRISE_PACK - ((this.servicesPrice.ENTERPRISE_PACK / 100) * discount)).toFixed(2));
          }}).catch((ex) => {
            this.promoid = '';
            this.setDefaultPrice();
            this.codeError = true;
        })
      } else {
        this.promoid = '';
        this.setDefaultPrice();
      }
    });
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  /* submit card details */
  cardSubmit(){
    this.errorMessage = null;
    if(this.cardForm.valid){
      let info = this.cardForm.value;
      if(info.number) info.number = info.number.replace(/\s/g, '');
      this.isLoading = true;
      if(this.userStatus == 'free' || this.userStatus == 'canceled'){
        this._dataService.createUpdateCard(info).toPromise().then((result: any) =>{
          if(result.code == 1001){
            this._dataService.createSubscription(info.product, this.promoid).toPromise().then((result: any) =>{
              if(result.code == 1001){
                this._toastrService.show('Subcription updated', {
                  delay: 3000,
                  classname: 'bg-primary text-light',
                  autohide: true
                });
                let product: string = info.product;
                let userinfo = this._authenticationService.currentUserValue;
                let fd = new FormData();
                fd.append('fullName', userinfo.user.fullName);
                fd.append('email', userinfo.user.email);
                fd.append('hearAboutUs', userinfo.user.hearAboutUs);
                fd.append('defaultProduct', product.split('_')[0]);
                fd.append('isNewsletter', userinfo.user.isNewsletter);
                this._dataService.updateUser(fd).toPromise().then((result)=>{
                  this._dataService.refreshUserToken().subscribe((result:any) =>{
                    this._authenticationService.setUser(result.data);
                    if(product == 'STOCK_CRYPTO_NFT'){
                      this._router.navigate(['/crypto']);
                    } else {
                      // if(product.split('_')[0] == 'NFT'){
                      //   this._router.navigate(['/nft']);
                      // } else
                      if(product.split('_')[0] == 'CRYPTO'){
                        this._router.navigate(['/crypto']);
                      } else {
                        this._router.navigate(['/stock']);
                      }
                    }
                    this.isLoading = false;
                  });
                });
                this.isLoading = false;
              }
            }).catch((err) =>{
              this.isLoading = false;
              this.errorMessage = err;
            });
          }
        }).catch((err) =>{
          this.isLoading = false;
          this.errorMessage = err;
        });
      } else {
        this._dataService.updateSubscription(info.product, this.promoid).toPromise().then((result: any) =>{
          if(result.code == 1001){
            this._toastrService.show('Subcription updated', {
              delay: 3000,
              classname: 'bg-primary text-light',
              autohide: true
            });
            let product: string = info.product;
            let userinfo = this._authenticationService.currentUserValue;
            let fd = new FormData();
            fd.append('fullName', userinfo.user.fullName);
            fd.append('email', userinfo.user.email);
            fd.append('hearAboutUs', userinfo.user.hearAboutUs);
            fd.append('defaultProduct', product.split('_')[0]);
            fd.append('isNewsletter', userinfo.user.isNewsletter);
            this._dataService.updateUser(fd).toPromise().then((result)=>{
              this._dataService.refreshUserToken().subscribe((result:any) =>{
                this._authenticationService.setUser(result.data);
                if(product == 'STOCK_CRYPTO_NFT'){
                  this._router.navigate(['/crypto']);
                } else {
                  // if(product.split('_')[0] == 'NFT'){
                  //   this._router.navigate(['/nft']);
                  // } else
                  if(product.split('_')[0] == 'CRYPTO'){
                    this._router.navigate(['/crypto']);
                  } else {
                    this._router.navigate(['/stock']);
                  }
                }
                this.isLoading = false;
              });
            });
          }
        }).catch((err) =>{
          this.isLoading = false;
          this.errorMessage = err;
        });
      }
    } else {
      this.errorMessage = 'Please select any service';
    }
  }

  setDefaultPrice(){
    this.servicesPrice = {
      SIX_MONTH_PACK: 299.94,
      YEARLY_PACK: 479.95,
      ENTERPRISE_PACK: 1800
    }
  }

}
